
import { defineComponent } from 'vue';

import VendorsSearch from '@/components/VendorsSearch.vue';
import GoogleMap from '@/components/GoogleMap.vue';

export default defineComponent({
  name: 'Routes',
  components: {
    VendorsSearch,
    GoogleMap
  }
});
